import clsx from "clsx";
import { useCallback, memo } from "react";

import { makeStyles } from "@material-ui/styles";
import { Grid, TextField, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/AddOutlined";

const filterStyles = makeStyles(() => ({
  filterRegion: {
    display: "flex",
    justifyContent: "flex-end",
    alignContent: "center",
  },
  filter: {
    marginBottom: 16,
  },
  closeIcon: {
    alignSelf: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function Property({
  properyIndex,
  propertyValue,
  onPropertyUpdate,
  onPropertyDelete,
}) {
  const classes = filterStyles();

  const handlePropertyChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      onPropertyUpdate(properyIndex, newValue);
    },
    [properyIndex, onPropertyUpdate]
  );

  const handlePropertyDelete = useCallback(
    (e) => {
      onPropertyDelete(properyIndex);
    },
    [properyIndex, onPropertyDelete]
  );

  return (
    <>
      <Grid container spacing={1} className={classes.filter}>
        <Grid item xs>
          {/* TODO: make this autocompletable. but not super clear about how to do that now */}
          <TextField
            fullWidth
            autoComplete="off"
            label="Allowed Property"
            name="value"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            value={propertyValue}
            onChange={handlePropertyChange}
            placeholder={
              "Examples: request/url, request/headers/Accept, response/body/*/order_id"
            }
          />
        </Grid>
        <Grid className={clsx(classes.closeIcon)} item xs={1}>
          <CloseIcon onClick={handlePropertyDelete} />
        </Grid>
      </Grid>
    </>
  );
}

const PropertyMemo = memo(Property);

function AllowedPropertyList({ values, onUpdate }) {
  const classes = filterStyles();

  const onPropertyUpdate = useCallback(
    (index, val) => {
      const newValues = [
        ...values.slice(0, index),
        val,
        ...values.slice(index + 1),
      ];
      onUpdate(newValues);
    },
    [values, onUpdate]
  );

  const onPropertyDelete = useCallback(
    (index) => {
      const newValues = [...values.slice(0, index), ...values.slice(index + 1)];
      onUpdate(newValues);
    },
    [values, onUpdate]
  );

  const handleAddProperty = useCallback(() => {
    const newValues = [...values, ""];
    onUpdate(newValues);
  }, [values, onUpdate]);

  return (
    <>
      {values.map((value, i) => (
        <PropertyMemo
          key={i}
          properyIndex={i}
          propertyValue={value}
          onPropertyUpdate={onPropertyUpdate}
          onPropertyDelete={onPropertyDelete}
        />
      ))}

      <div className={classes.filterRegion}>
        <Button color="default" onClick={handleAddProperty} variant="outlined">
          <AddIcon className={classes.icon} />
          Add Allowed Property
        </Button>
      </div>
    </>
  );
}

const AllowedPropertyListMemo = memo(AllowedPropertyList);

export default AllowedPropertyList;
